import { api } from '@/services/api';

/** Os quatro passos que destravam o produto numa conta nova. */
export interface PassosOnboarding {
  site: boolean;
  ia: boolean;
  marca: boolean;
  materia: boolean;
}

export interface ResumoOnboarding {
  passos: PassosOnboarding;
  feitos: number;
  total: number;
  concluido: boolean;
}

export const onboardingApi = {
  // 404 é resposta legítima aqui: uma instância mais antiga não tem esta rota.
  // Sem `esperados`, abrir o produto contra um backend defasado dispararia o
  // alarme vermelho global por causa de um painel de boas-vindas.
  resumo: () => api.get<ResumoOnboarding>('/onboarding', { esperados: [404] }),
};
